import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const callTimecardsGrid = async (freq, vms) => {
    try {
        let getUrl = `${BaseUrl}Home/getTimecardFollowUp`;
        const res = await axios.get(getUrl, JsonConfig)
        if (res.data.statusCode === 200) {
            const sample = JSON.parse(res.data.payload)
            if ((freq !== '') && (vms !== '' )) {
                const filteredData = sample.filter((item) => ((item.Frequency === freq) && (item.Portal === vms)));
                return filteredData;
            }
            else if((freq === '' ) && (vms !== '') ){
                const filteredData = sample.filter((item) => (item.Portal === vms));
                return filteredData;
            }
            else if((freq !== '') && (vms === '')){
                const filteredData = sample.filter((item) => (item.Frequency === freq));
                return filteredData;
            }
            else { return sample; }
        }
        else {
            InfoMessage("There is no data!!!");
            return null;
        }
    }
    catch {
        ErrorMessage("Data Fetching was Failed");
        return null;
    }
}
export const updateNote = async (props) => {
    try {
        const data = props;
        let getUrl = `${BaseUrl}Home/editnote`;
        const res = await axios.put(getUrl, data, JsonConfig);
        if (res.data.statusCode === 200) {
            return res.data.message;
        }
        else {
            InfoMessage(res.data.message);
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to update, please try again");
        return null;
    }
}
export const triggerMail = async (props) => {
    try {
        console.log(props)
        const data = props;
        const filteredData = data.filter((item) => (item.TC_Status === "Missing" && item.RT === "0.00"));
        let getUrl = `${BaseUrl}HelpSupport/sendmail_CLient`;
        const res = await axios.post(getUrl, filteredData, JsonConfig);
        if (res.data.statusCode === 200) {
            return res.data.message;
        }
        else if (res.data.statusCode === 201) {
            return res.data.message;
        }
        else {
            InfoMessage(res.data.message);
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to send, please try again");
        return null;
    }
}

export const getAutocrawlData = async () => {
    try {
        let url = `${BaseUrl}Home/autocrawltimecardfolloup`;
        const res = await axios.get(url, JsonConfig)
        if (res.status === 200) {
            const sample = JSON.parse(res.data)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get autocrawl data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get autocrawl data");
        return null;
    }
}

export const getStatusDumpData = async () => {
    try {
        let url = `${BaseUrl}Home/statusdumpdata`
        const res = await axios.get(url, JsonConfig);
        if (res.data.statusCode === 200) {
            return "success";
        }
        else {
            ErrorMessage(res.data.message);
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to process data, please try again");
        return null;
    }
}

export const downloadAutoCrawledFiles = async () => {
    try {
        let url = `${BaseUrl}Home/DownloadZipFile_timecard?filename=AutoCrawling_User`;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: "blob",
        }
        const response = await axios.get(url, config);
        if (response.status === 200) {
            fileDownload(response.data, "TimecardFiles.zip");
        }
        else {
            ErrorMessage("Cannot able to download");
        }
    }
    catch {
        ErrorMessage("Internal error, cannot able to download");
    }
}
export const TSCsvDownload = async (props) => {
    try {
        const temp = props;
        if (temp.length > 0) {
            let sampleList = temp;
            let loopedList = [];
            loopedList.length = 0;
            let len = sampleList.length;
            let i;
            loopedList.push(['CSA', 'CSM', 'EE', 'Client', 'ECS', 'Email', 'Category',
                'Excempt Status', 'TC Status', 'ST', 'DT', 'OT', 'Other', 'Timecard Coordinator',
                'Week Ending', 'Notes',])
            for (i = 0; i < len; i++) {
                loopedList.push([
                    sampleList[i].CSA,
                    sampleList[i].CSM,
                    sampleList[i].EE,
                    // sampleList[i].CS_Director,
                    sampleList[i].Client,
                    sampleList[i].Ecs,
                    sampleList[i].Email,
                    sampleList[i].Category,
                    sampleList[i].ExemptStatus,
                    sampleList[i].TC_Status,
                    sampleList[i].RT,
                    sampleList[i].DT,
                    sampleList[i].OT,
                    sampleList[i].OTHER,
                    sampleList[i].Timecard_Coordinator,
                    sampleList[i].Week_Ending,
                    sampleList[i].Note,
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'TimesheetGrid.csv');
                });

            return "downloaded"
        }
        else { return null }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}
export const downloadXL = async (val, grid) => {
    try {
        const value = val;
        const data = grid;
        if (data.length > 0) {
            if (value === 'one') {
                const sampleList = data.filter((item) =>
                (item.TC_Status === "Pending Approval" || item.TC_Status === "Pending Review by Supplier" || item.TC_Status === "Rejected" || item.TC_Status === "Draft"
                    || item.TC_Status === "Saved" || item.TC_Status === "Pending" || item.TC_Status === "Approval Pending" || item.TC_Status === "Under Development"
                    || item.TC_Status === "Submitted" || item.TC_Status === "No" || item.TC_Status === "Not Submitted" || item.TC_Status === "Open"));
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                loopedList.push(['Client', 'CSA', 'EE', 'Email', 'ECS', 'Work State', 'TC Status',
                    'ST', 'DT', 'OT', 'Other', 'Week ending', 'Timecard Coordinator', 'CS Director',
                    'CSM',])
                for (i = 0; i < len; i++) {
                    let rt;
                    if (sampleList[i].RT !== null) {
                        if (sampleList[i].RT !== "") {
                            rt = parseFloat(sampleList[i].RT)
                        }
                    }
                    let dt;
                    if (sampleList[i].DT !== null) {
                        if (sampleList[i].DT !== "") {
                            dt = parseInt(sampleList[i].DT)
                        }
                    }
                    let ot;
                    if (sampleList[i].OT !== null) {
                        if (sampleList[i].OT !== "") {
                            ot = parseFloat(sampleList[i].OT)
                        }
                    }
                    let other;
                    if (sampleList[i].OTHER !== null) {
                        if (sampleList[i].OTHER !== "") {
                            other = parseFloat(sampleList[i].OTHER)
                        }
                    }
                    loopedList.push([
                        sampleList[i].Client,
                        sampleList[i].CSA,
                        sampleList[i].EE,
                        sampleList[i].Email,
                        sampleList[i].Ecs,
                        sampleList[i].ExemptStatus,
                        sampleList[i].TC_Status,
                        rt,
                        dt,
                        ot,
                        other,
                        sampleList[i].Week_Ending,
                        sampleList[i].Timecard_Coordinator,
                        sampleList[i].CS_Director,
                        sampleList[i].CSM,

                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                for (i = 0; i < loopedList.length; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                worksheet.getRow(1).fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFC000" },
                    color: { argb: 'FF0000' }
                };
                const row1Content = loopedList[0];
                worksheet.getRow(1).values = row1Content;
                worksheet.getRow(1).eachCell({ includeEmpty: false }, (cell) => {
                    cell.font = {
                        name: 'Dubai Light',
                        bold: true,
                        color: { argb: 'FFFFFF' }
                    };
                });
                worksheet.getRow(1).height = 30;
                worksheet.columns.forEach((column) => {
                    column.eachCell({ includeEmpty: false }, (cell) => {
                        cell.border = {
                            top: { style: 'thin', color: { argb: '000000' } },
                            bottom: { style: 'thin', color: { argb: '000000' } },
                            left: { style: 'thin', color: { argb: '000000' } },
                            right: { style: 'thin', color: { argb: '000000' } }
                        };
                    });
                });
                for (i = 1; i <= loopedList[0].length; i++) {
                    worksheet.getColumn(i).width = 25;
                }
                worksheet.getRow(1).alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                };
                for (let i = 0; i <= loopedList.length; i++) {
                    worksheet.getRow(i + 2).font = {
                        name: 'Dubai Light',
                    };
                }
                workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'REPORT - MISSING_REJECTED_PENDING TIMECARDS.xlsx');
                    });

                return "downloaded"
            }
            else if (value === 'two') {
                const sampleList = data.filter((item) =>
                (item.Category === 'A' && (item.TC_Status === "Draft" || item.TC_Status === "Saved" || item.TC_Status === "" ||
                    item.TC_Status === "Submitted" || item.TC_Status === "Not Submitted" || item.TC_Status === "No"
                    || item.TC_Status === "Open")));
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                loopedList.push(['Client', 'CSA', 'EE', 'Email', 'ECS', 'Work State', 'TC Status',
                    'Req category', 'CD', 'Notes'])
                for (i = 0; i < len; i++) {
                    loopedList.push([
                        sampleList[i].Client,
                        sampleList[i].CSA,
                        sampleList[i].EE,
                        sampleList[i].Email,
                        sampleList[i].Ecs,
                        sampleList[i].ExemptStatus,
                        sampleList[i].TC_Status,
                        "A",
                        sampleList[i].CS_Director,
                        sampleList[i].Note
                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                for (i = 0; i < loopedList.length; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                worksheet.getRow(1).fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFC000 " },
                    color: { argb: 'FF0000' }
                };
                const row1Content = loopedList[0];
                worksheet.getRow(1).values = row1Content;
                worksheet.getRow(1).eachCell({ includeEmpty: false }, (cell) => {
                    cell.font = {
                        name: 'Dubai Light',
                        bold: true,
                        color: { argb: 'FFFFFF' }
                    };
                });
                worksheet.getRow(1).height = 30;
                worksheet.columns.forEach((column) => {
                    column.eachCell({ includeEmpty: false }, (cell) => {
                        cell.border = {
                            top: { style: 'thin', color: { argb: '000000' } },
                            bottom: { style: 'thin', color: { argb: '000000' } },
                            left: { style: 'thin', color: { argb: '000000' } },
                            right: { style: 'thin', color: { argb: '000000' } }
                        };
                    });
                });
                for (i = 1; i <= loopedList[0].length; i++) {
                    worksheet.getColumn(i).width = 25;
                }
                worksheet.getRow(1).alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                };
                for (let i = 0; i < loopedList.length; i++) {
                    worksheet.getRow(i + 2).font = {
                        name: 'Dubai Light',
                    };
                }
                workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'REPORT - MISSING_REJECTED_SUBMITTED TIMECARDS - A Reqs.xlsx');
                    });

                return "downloaded"
            }
            else if (value === 'three') {
                const sampleList = data.filter((item) =>
                (item.Category === 'Category C' && (item.TC_Status === "Draft" || item.TC_Status === "Saved" || item.TC_Status === "" ||
                    item.TC_Status === "Submitted" || item.TC_Status === "Not Submitted" || item.TC_Status === "No"
                    || item.TC_Status === "Open")));
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                loopedList.push(['Client', 'CSA', 'EE', 'Email', 'ECS', 'Work State', 'TC Status',
                    'Req category', 'CDM', 'Notes'])
                for (i = 0; i < len; i++) {
                    loopedList.push([
                        sampleList[i].Client,
                        sampleList[i].CSA,
                        sampleList[i].EE,
                        sampleList[i].Email,
                        sampleList[i].Ecs,
                        sampleList[i].ExemptStatus,
                        sampleList[i].TC_Status,
                        "Category C",
                        "",
                        // sampleList[i].CSM,
                        sampleList[i].Note
                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                for (i = 0; i < loopedList.length; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                worksheet.getRow(1).fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFC000 " },
                    color: { argb: 'FF0000' }
                };
                const row1Content = loopedList[0];
                worksheet.getRow(1).values = row1Content;
                worksheet.getRow(1).eachCell({ includeEmpty: false }, (cell) => {
                    cell.font = {
                        name: 'Dubai Light',
                        bold: true,
                        color: { argb: 'FFFFFF' }
                    };
                });
                worksheet.getRow(1).height = 30;
                worksheet.columns.forEach((column) => {
                    column.eachCell({ includeEmpty: false }, (cell) => {
                        cell.border = {
                            top: { style: 'thin', color: { argb: '000000' } },
                            bottom: { style: 'thin', color: { argb: '000000' } },
                            left: { style: 'thin', color: { argb: '000000' } },
                            right: { style: 'thin', color: { argb: '000000' } }
                        };
                    });
                });
                for (i = 1; i <= loopedList[0].length; i++) {
                    worksheet.getColumn(i).width = 25;
                }
                worksheet.getRow(1).alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                };
                for (let i = 0; i < loopedList.length; i++) {
                    worksheet.getRow(i + 2).font = {
                        name: 'Dubai Light',
                    };
                }
                workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'REPORT - MISSING TIMESHEETS.xlsx');
                    });

                return "downloaded"
            }
            else if (value === 'four') {
                const looped = [];
                data.forEach(sample => {
                    let rt;
                    if (sample.RT !== null) {
                        if (sample.RT !== "") {
                            rt = parseFloat(sample.RT)
                        }
                    }
                    let dt;
                    if (sample.DT !== null) {
                        if (sample.DT !== "") {
                            dt = parseInt(sample.DT)
                        }
                    }
                    let ot;
                    if (sample.OT !== null) {
                        if (sample.OT !== "") {
                            ot = parseFloat(sample.OT)
                        }
                    }
                    let other;
                    if (sample.OTHER !== null) {
                        if (sample.OTHER !== "") {
                            other = parseFloat(sample.OTHER)
                        }
                    }
                    looped.push({
                        "Id": sample.Id,
                        "CSA": sample.CSA,
                        "CSM": sample.CSM,
                        "EE": sample.EE,
                        "CS_Director": sample.CS_Director,
                        "Client": sample.Client,
                        "Ecs": sample.Ecs,
                        "Email": sample.Email,
                        "RT": rt,
                        "DT": dt,
                        "OT": ot,
                        "OTHER": other,
                        "ExemptStatus": sample.ExemptStatus,
                        "TC_Status": sample.TC_Status,
                        "Timecard_Coordinator": sample.Timecard_Coordinator,
                        "Week_Ending": sample.Week_Ending,
                        "Note": "",
                    })
                })
                const sampleList = looped.filter((item) => (item.RT > 40 || item.OT > 5 || (item.RT < 40 && item.OT > 0)));
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                for (i = 0; i < len; i++) {
                    loopedList.push([
                        sampleList[i].Client,
                        sampleList[i].CSA,
                        sampleList[i].EE,
                        sampleList[i].Email,
                        sampleList[i].Ecs,
                        sampleList[i].ExemptStatus,
                        sampleList[i].TC_Status,
                        sampleList[i].RT,
                        sampleList[i].OT,
                        sampleList[i].DT,
                        sampleList[i].OTHER,
                        sampleList[i].Note
                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                worksheet.getRow(1).values = ['Client', 'CSA', 'EE', 'Email', 'ECS', 'Work State', 'TC Status', 'Week', '', '', '', 'Notes'];
                worksheet.getRow(2).values = ['', '', '', '', '', '', '', 'ST', 'OT', 'DT', 'Other', ''];
                worksheet.mergeCells(`A1:A2`);
                worksheet.mergeCells(`B1:B2`);
                worksheet.mergeCells(`C1:C2`);
                worksheet.mergeCells(`D1:D2`);
                worksheet.mergeCells(`E1:E2`);
                worksheet.mergeCells(`F1:F2`);
                worksheet.mergeCells(`G1:G2`);
                worksheet.mergeCells(`L1:L2`);
                worksheet.mergeCells(`H1:K1`)
                const mergedCellStyle = {
                    font: {
                        name: 'Dubai Light',
                        bold: true,
                        color: { argb: 'FFFFFF' }
                    },
                    fill: {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFC000" },
                        color: { argb: 'FFFFFF' }
                    },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center'
                    },
                };
                const mergedCell = {
                    font: {
                        name: 'Dubai Light',
                        bold: true,
                        color: { argb: 'FFFFFF' }
                    },
                    fill: {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFC000" },
                        color: { argb: 'FFFFFF' }
                    },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center'
                    },
                };
                worksheet.getCell('A1').style = mergedCellStyle;
                worksheet.getCell('B1').style = mergedCellStyle;
                worksheet.getCell('C1').style = mergedCellStyle;
                worksheet.getCell('D1').style = mergedCellStyle;
                worksheet.getCell('E1').style = mergedCellStyle;
                worksheet.getCell('F1').style = mergedCellStyle;
                worksheet.getCell('G1').style = mergedCellStyle;
                worksheet.getCell('H1').style = mergedCellStyle;
                worksheet.getCell('L1').style = mergedCellStyle;
                worksheet.getCell('H2').style = mergedCell;
                worksheet.getCell('I2').style = mergedCell;
                worksheet.getCell('J2').style = mergedCell;
                worksheet.getCell('K2').style = mergedCell;
                for (i = 0; i < loopedList.length; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                worksheet.columns.forEach((column) => {
                    column.eachCell({ includeEmpty: false }, (cell) => {
                        cell.border = {
                            top: { style: 'thin', color: { argb: '000000' } },
                            bottom: { style: 'thin', color: { argb: '000000' } },
                            left: { style: 'thin', color: { argb: '000000' } },
                            right: { style: 'thin', color: { argb: '000000' } }
                        };
                    });
                });
                worksheet.getColumn(1).width = 23;
                worksheet.getColumn(2).width = 23;
                worksheet.getColumn(3).width = 23;
                worksheet.getColumn(4).width = 25;
                worksheet.getColumn(5).width = 23;
                worksheet.getColumn(6).width = 15;
                worksheet.getColumn(7).width = 20;
                worksheet.getColumn(8).width = 10;
                worksheet.getColumn(9).width = 10;
                worksheet.getColumn(10).width = 10;
                worksheet.getColumn(11).width = 10;
                worksheet.getColumn(12).width = 30;
                for (let i = 0; i < loopedList.length; i++) {
                    worksheet.getRow(i + 3).font = {
                        name: 'Dubai Light',
                    };
                }
                workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'REPORT - ST.OT.DT. TIMECARD ERRORS.xlsx');
                    });

                return "downloaded"
            }
        }
        else {
            InfoMessage("There is no data to download")
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to download, try again.")
        return null;
    }
}